export const EolResult = {
  DISCONTINUED: 'discontinued',
  DISCONTINUED_GROUP: 'discontinued_groupSubstitution',
  SUBSTITUTE: 'substitute'
};